import { Col, Flex, Form, Row, Select } from "antd";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import { useEffect } from "react";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { ColumnsType } from "antd/lib/table";
import { PlanoContaResultadoModel } from "../../models/planoContaResultado/planoContaResultadoModel";
import { alterarIndicadorPlanoContaResultado, listarIndicadorCalculoResultado, listarPlanoContaResultado } from "../../services/planoContaResultadoService";
import Search from "antd/es/input/Search";
import { setBuscaPlanoContaResultado } from "../../redux/slices/planoContaResultado/planoContaResultadoSlice";
import { BuscaPlanoContaResultadoModel } from "../../models/planoContaResultado/buscaPlanoContaResultadoModel";
import { IndicadoresModel } from "../../models/planoContaResultado/indicadoresModel";
import { AlterarIndicadorPlanoContaResultadoModel } from "../../models/planoContaResultado/alterarIndicadorPlanoContaResultadoModel";
import TableComponent from "../../components/table/tableComponent";
import { removeFilhos } from "../../util/functions/removeFilhos";
import { SwitchComponent } from "../../components/button/switch";

const PlanoContaFinanceiroResultado = () => {
  //estados globais
  const planoContaResultadoState = useAppSelector((state) => state.planoContaResultado);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(setTitle("PARAMETRIZAÇÃO DO PONTO DE EQUILÍBRIO"));
    dispatch(listarPlanoContaResultado(planoContaResultadoState.busca));
    dispatch(listarIndicadorCalculoResultado());
    form.setFieldsValue({ codigoIndicador: "DESP_FIN_ENTIDADE", idGrupoPlanoContaFinanceiro: 1 });
  }, []);

  const onChangeAssociado = (value: PlanoContaResultadoModel) => {
    const codigoIndicador = form.getFieldValue("codigoIndicador");
    let indicarEscolhido: IndicadoresModel = planoContaResultadoState.listIndicadores.filter((a: IndicadoresModel) => a.codigo === codigoIndicador)[0];
    let listaPlanos = indicarEscolhido.listaCodigoPlanoContaFinanceiro.split("|");
    if (listaPlanos.includes(value.codigo)) {
      // Se estiver presente, remova-a do array
      listaPlanos = listaPlanos.filter((a) => a !== value.codigo);
    } else {
      // Se não estiver presente, adicione-a ao array
      listaPlanos = listaPlanos.concat(value.codigo);
    }
    var args: AlterarIndicadorPlanoContaResultadoModel = {
      codigoIndicador: codigoIndicador,
      listaCodigoPlanoContaFinanceiro: listaPlanos.join("|"),
    };
    dispatch(alterarIndicadorPlanoContaResultado({ value: args, busca: planoContaResultadoState.busca }));
  };

  const onChangeTable = async (pagination: any, filters: any) => {
    let busca: BuscaPlanoContaResultadoModel = { ...planoContaResultadoState.busca };
    //ativo
    if (filters.ativo !== null) {
      if (filters.ativo.length === 2) {
        busca.ativo = null;
      }
      if (filters.ativo.length === 1) {
        if (filters.ativo[0] === "true") {
          busca.ativo = true;
        }
        if (filters.ativo[0] === "false") {
          busca.ativo = false;
        }
      }
    } else {
      busca.ativo = null;
    }
    //associado
    if (filters.associado !== null) {
      if (filters.associado.length === 2) {
        busca.associado = null;
      }
      if (filters.associado.length === 1) {
        if (filters.associado[0] === "true") {
          busca.associado = true;
        }
        if (filters.associado[0] === "false") {
          busca.associado = false;
        }
      }
    } else {
      busca.associado = null;
    }
    dispatch(setBuscaPlanoContaResultado(busca));
    dispatch(listarPlanoContaResultado(busca));
  };

  const onSearch = (value: string) => {
    let busca: BuscaPlanoContaResultadoModel = { ...planoContaResultadoState.busca, pesquisar: value };

    dispatch(setBuscaPlanoContaResultado(busca));
    dispatch(listarPlanoContaResultado(busca));
  };

  const onChangeIndicador = (value: string) => {
    let busca: BuscaPlanoContaResultadoModel = { ...planoContaResultadoState.busca, codigoIndicador: value };

    dispatch(setBuscaPlanoContaResultado(busca));
    dispatch(listarPlanoContaResultado(busca));
  };

  const columns: ColumnsType<PlanoContaResultadoModel> = [
    {
      title: "PLANO DE CONTA",
      dataIndex: "denominacaoCompleta",
    },
    {
      title: "CÓDIGO",
      dataIndex: "codigo",
      align: "center",
    },
    {
      title: "TIPO",
      dataIndex: "receitaDespesa",
      align: "center",
      render: (_, record) => (record.receitaDespesa.toLowerCase() === "r" ? "Receita" : "Despesa"),
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      align: "center",
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      defaultFilteredValue: ["true" as any],
      render: (_, record) => (record.idPai === null ? "" : <SwitchComponent disabled checked={record.ativo} />),
    },
    {
      title: "ASSOCIADO",
      dataIndex: "associado",
      align: "center" as "center",
      filters: [
        {
          text: "Sim",
          value: "true" as any,
        },
        {
          text: "Não",
          value: "false" as any,
        },
      ],
      defaultFilteredValue: ["true" as any],
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) =>
        record.idPai === null ? (
          ""
        ) : record.filhos?.length === 0 && record.codigo.length !== 5 ? (
          <SwitchComponent checked={record.associado} disabled />
        ) : (
          <SwitchComponent onChange={() => onChangeAssociado(record)} checked={record.associado} />
        ),
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={24}>
            <Flex gap={12}>
              <Form.Item label="Grupo de plano de conta financeiro" name="idGrupoPlanoContaFinanceiro">
                <Select
                  showSearch
                  optionFilterProp="label"
                  placeholder="Selecione o sorteio"
                  disabled
                  style={{ width: 200 }}
                  options={[
                    {
                      value: 1,
                      label: "EMPRESAS DÁ SORTE",
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item
                label="Parâmetros"
                name="codigoIndicador"
                rules={[
                  {
                    required: true,
                    message: "Selecione um indicador",
                  },
                ]}
              >
                <Select
                  showSearch
                  style={{ width: 450 }}
                  optionFilterProp="label"
                  placeholder="Selecione o indicador"
                  loading={planoContaResultadoState.loadingIndicadores}
                  options={planoContaResultadoState.listIndicadores.map((a: any) => ({
                    value: a.codigo,
                    label: a.denominacao,
                  }))}
                  onChange={onChangeIndicador}
                />
              </Form.Item>
              <Form.Item label="Pesquisar" name="pesquisa">
                <Search allowClear style={{ width: 400 }} placeholder="Plano de conta financeiro" onSearch={onSearch} className="searchInput" enterButton />
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent
        columns={columns}
        loading={planoContaResultadoState.loading}
        data={removeFilhos(planoContaResultadoState.list)}
        expandable={{
          childrenColumnName: "filhos",
          expandRowByClick: true,
        }}
        tableProps={{
          onChange: onChangeTable,
          className: "tableCentroCusto",
        }}
      />
    </Flex>
  );
};

export default PlanoContaFinanceiroResultado;
